import {defaultSettings} from './default.mjs'
import {customerSettings} from "./customer.mjs";
import merge from 'lodash/merge.js';

export const settings = merge(defaultSettings, customerSettings);

